// extracted by mini-css-extract-plugin
module.exports = {"table":"ResultTableComponent_table__dSF1w","th":"ResultTableComponent_th__3XM1Z","tr":"ResultTableComponent_tr__493F9","td":"ResultTableComponent_td__1vLm8"};